import { gql } from "@apollo/client";

export const CREATE_NOTIFICATION_SETTING = gql`
mutation CreateNotificationSetting($input: CreateNotificationSettingInputDto!) {
  createNotificationSetting(input: $input) {
    message
  }
}`

export const UPDATE_NOTIFICATION_SETTING_BY_ID = gql`
mutation UpdateNotificationSetting($input: updateNotificationSettingInputDto!) {
  updateNotificationSetting(input: $input) {
    message
  }
}
`


export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotificationLog($input: DeleteNotificationLogInput!) {
    deleteNotificationLog(input: $input) {
      message
    }
  }
`;


export const MARK_NOTIFICATION_AS_READ = gql`
mutation MarkNotificationAsRead($input: MarkAsReadInput!) {
  markNotificationAsRead(input: $input) {
    message
  }
}
`

export const MARK_ALL_NOTIFICATION_AS_READ = gql`
mutation MarkAllNotificationsAsRead {
  markAllNotificationsAsRead {
    message
  }
}
`